import React, { Fragment, createContext } from 'react';

import { getConfig, MODE } from '../config';
import type { LazySuspenseContextType } from './types';

export const LazySuspenseContext: React.Context<LazySuspenseContextType> =
	createContext<LazySuspenseContextType>({
		getIsBoundaryInitialized: () => false,
		fallback: <Fragment />,
		setFallback: () => {
			if (getConfig().mode === MODE.RENDER) {
				// render mode MUST have a properly configured boundary
				// eslint-disable-next-line no-console
				console.warn('Missing <LooselySuspense /> boundary');
			}
		},
	});
